import { API_URL } from './api';
import { clearLocalStorageKeepingLoginHint } from '../config/authStorageKeys';

const fetchWithHandling = async (url, options) => {
  try {
    options.credentials = 'include';
    const response = await fetch(url, options);

    if (response.status === 401) {
      clearLocalStorageKeepingLoginHint();
      window.location.href = '/login';
      throw new Error('Unauthorized: Token expired or invalid.');
    }

    if (!response.ok) {
      const errorDetails = await response.json().catch(() => ({}));
      throw new Error(
        errorDetails.error ||
          errorDetails.detail ||
          errorDetails.message ||
          `Error: ${response.status} ${response.statusText}`,
      );
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};

export const fetchGoogleCalendarEvents = async (token, days = 7) => {
  return fetchWithHandling(
    `${API_URL}/web/api/calendar/events/google?days=${days}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const fetchOutlookCalendarEvents = async (token, days = 7) => {
  return fetchWithHandling(
    `${API_URL}/web/api/calendar/events/outlook?days=${days}`,
    {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};
